/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ServiceDeskCmdbInsightObjectView from '@jira/spa-apps__servicedesk-cmdb-object-v2/src/ConditionalRedirectOrRouteView.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbObjectV2: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServiceDeskCmdbInsightObjectView
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-cmdb-object-v2", jiraSpaEntry: "async-servicedesk-cmdb-object-v2" */ '@jira/spa-apps__servicedesk-cmdb-object-v2/src/ConditionalRedirectOrRouteView.tsx'
		),
);

export const InsightCmdbObjectViewV2 = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbObjectV2}
		pageId="spa-apps/servicedesk/insight/cmdb-object-v2"
		shouldShowSpinner
	/>
);

export default InsightCmdbObjectViewV2;
